import { musicPlatform } from 'fitbeat.gym-core/config';
import React, { FunctionComponent } from 'react';
import { StyleProp, StyleSheet, Text, TouchableOpacity, View, ViewStyle } from 'react-native';
import { moderateScale } from 'react-native-size-matters';
import { connect } from 'react-redux';
import ChevronIcon from '../../../assets/images/chevron.svg';
import MusicNoteIcon from '../../../assets/images/home-workouts/music-note.svg';
import Theme from '../../../theme';
import { fullScale } from '../../../utils/scaling';
import { IAppStore } from '../../reducer';
import { DeviceSetupScreens } from '../../utils/DeviceSetupScreens';
import {
  genericMusicIsPausedSelector,
  genericMusicPause,
  genericMusicPlay,
  genericMusicSkipToNext,
  genericMusicSkipToPrevious, getMusicPlayerStateSelector,
  getSelectedMusicPlayerSelector, IPlayerState,
  nowPlayingTextSelector,
  pausePlayback,
  resumePlayback,
  skipBackward,
  skipForward,
} from '../Music';
import { MusicControlButtons } from './MusicControlButtons';

interface IProps {
  openSetupScreen: (screen: DeviceSetupScreens) => void;
  genericMusicPlayingState: (playing: boolean) => void;
  genericMusicSkipToNext: () => void;
  genericMusicSkipToPrevious: () => void;
  genericMusicPause: () => void;
  genericMusicPlay: () => void;
  musicPlayer: string | null;
  resumePlayback: () => void;
  pausePlayback: () => void;
  skipForward: () => void;
  skipBackward: () => void;
  nowPlayingText: string;
  musicPlayerState: IPlayerState | null;
  isGroupWorkout: boolean;
  musicTitleContainerStyle?: StyleProp<ViewStyle>;
  genericMusicIsPlaying: boolean;
}

const DeviceSetupMusicPlayerComponent: FunctionComponent<IProps> = ({
                                                                      openSetupScreen,
                                                                      genericMusicPause: genericPause,
                                                                      genericMusicPlay: genericPlay,
                                                                      genericMusicSkipToNext: genericSkipNext,
                                                                      genericMusicSkipToPrevious: genericSkipPrevious,
                                                                      musicPlayer,
                                                                      resumePlayback: play,
                                                                      pausePlayback: pause,
                                                                      skipForward: forward,
                                                                      skipBackward: back,
                                                                      nowPlayingText,
                                                                      musicPlayerState,
                                                                      isGroupWorkout,
                                                                      musicTitleContainerStyle,
                                                                      genericMusicIsPlaying,
                                                                    }) => {

  const iconSize = {
    height: fullScale(20),
    width: fullScale(20),
  };

  const musicTitleSection = () => {
    return (
      <View style={[{ flexDirection: 'row' }, musicTitleContainerStyle]}>
        <MusicNoteIcon color={Theme.WHITE} {...iconSize} />
        <Text style={styles.nowPlayingText}>{nowPlayingText}</Text>
        <ChevronIcon color={Theme.WHITE} {...iconSize} />
      </View>
    );
  };

  const isNonGenericMusicPaused = musicPlayerState && musicPlayerState.isPaused;
  return (
    <View style={styles.container} >
      <TouchableOpacity onPress={() => openSetupScreen(DeviceSetupScreens.Music)}
                        style={[styles.titleContainer]}>
        {musicTitleSection()}
      </TouchableOpacity>
      <View>
        {(musicPlayer === musicPlatform.AppleMusic || musicPlayer === musicPlatform.Spotify) &&
        <MusicControlButtons isPlaying={!isNonGenericMusicPaused} pause={pause} play={play}
                             skipForward={forward}
                             skipBackward={back} canSkipNext={!!(musicPlayerState && musicPlayerState.canSkipNext)}
                             canSkipPrevious={!!(musicPlayerState && musicPlayerState.canSkipPrevious)} />
        }
        {
          musicPlayer === musicPlatform.FitbeatMusic &&
          <MusicControlButtons isPlaying={genericMusicIsPlaying} pause={genericPause} play={genericPlay}
                               skipForward={genericSkipNext}
                               skipBackward={genericSkipPrevious} canSkipPrevious canSkipNext />
        }
        {
          !musicPlayer &&
          <MusicControlButtons isPlaying={false} pause={() => null} play={() => null}
                               skipForward={() => null}
                               skipBackward={() => null} canSkipPrevious canSkipNext />
        }
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderTopColor: Theme.GREY_DARK_MEDIUM,
    borderTopWidth: 1,
    paddingTop: 15,
  },
  nowPlayingText: {
    ...Theme.textStyle.bodyCopyReg,
    fontSize: moderateScale(12, 0.75),
    color: Theme.WHITE,
    marginHorizontal: fullScale(15),
    marginTop: fullScale(1.8),
  },
  titleContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
});

const mapStateToProps = (state: IAppStore): Partial<IProps> => {
  return {
    musicPlayer: getSelectedMusicPlayerSelector(state),
    nowPlayingText: nowPlayingTextSelector(state),
    musicPlayerState: getMusicPlayerStateSelector(state),
    genericMusicIsPlaying: !genericMusicIsPausedSelector(state),
  };
};

const mapDispatchToProps = (dispatch: any): Partial<IProps> => {
  return {
    genericMusicSkipToNext: () => dispatch(genericMusicSkipToNext()),
    genericMusicSkipToPrevious: () => dispatch(genericMusicSkipToPrevious()),
    genericMusicPause: () => dispatch(genericMusicPause()),
    genericMusicPlay: () => dispatch(genericMusicPlay()),
    resumePlayback: () => dispatch(resumePlayback()),
    pausePlayback: () => dispatch(pausePlayback()),
    skipBackward: () => dispatch(skipBackward()),
    skipForward: () => dispatch(skipForward()),
  };
};

export const DeviceSetupMusicPlayer = connect(mapStateToProps, mapDispatchToProps)(DeviceSetupMusicPlayerComponent);
